import React, { useState, useEffect } from 'react';
import logoutMobile from "../../assets/images/stepperLogout.svg";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { guestUserLogout } from "../../common/guestUserLogout";
import LogoutModal from "../LogoutModal/LogoutModal";

const EducationalContentHeader = ({
  hideBackButton = false,
  backBtnSrc,
  backBtnMobileSrc,
  onBack,
  title,
  hideNavigation,
  stepText,
  progress,
  children,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isLogoutModal, setIsLogoutModal] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isThankYouPage = location.pathname.includes("/guest-user/thank-you");
  const isEnrollmentSuccess =
    location.state?.enrollmentDecision?.toUpperCase() === "YES";
  const shouldShowLogout = isThankYouPage && isEnrollmentSuccess;

  const handleCancelLogout = () => setIsLogoutModal(false);

  const handleConfirmLogout = () => {
    setIsLogoutModal(false);
    guestUserLogout(dispatch, navigate);
  };

  useEffect(() => {
    const handlrResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handlrResize);
    return () => window.removeEventListener('resize', handlrResize);
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname])

  return (
    <>
      <div className="commonHeader stepperHeader">
        <div className="container">
          <div className="headerBg d-flex align-center justify-between">
            {isMobile ? (
              <>
                {!hideBackButton ? (
                  <>
                    <img
                      src={backBtnSrc}
                      onClick={onBack}
                      className="cursor-pointer backBtn"
                      alt=""
                    />
                    <img
                      src={backBtnMobileSrc}
                      onClick={onBack}
                      className="cursor-pointer backBtnMobile"
                      alt=""
                    />
                  </>
                ) : (
                  <div className="noSpaceDiv"></div>
                )}
                <h2 className="tgb">{title}</h2>
              </>
            ) : (
              <div className="d-flex align-center gap-16">
                {!hideBackButton && (
                  <>
                    <img
                      src={backBtnSrc}
                      onClick={onBack}
                      className="cursor-pointer backBtn"
                      alt=""
                    />
                    <img
                      src={backBtnMobileSrc}
                      onClick={onBack}
                      className="cursor-pointer backBtnMobile"
                      alt=""
                    />
                  </>
                )}
                <h2 className="tgb">{title}</h2>
              </div>

            )}
            {!shouldShowLogout ? (
              <button
                type="button"
                className="educationalLogoutBtn d-flex align-center gap-16"
                onClick={() => setIsLogoutModal(true)}
                aria-label={t("Logout")}
              >
                <img src={logoutMobile} alt="" />
                <span className="educationalLogoutText">{t("Logout")}</span>
              </button>
            ) : <div className="noSpaceDiv"></div>}
          </div>
        </div>
      </div>
      <div className="container marginTop80 noMobileMargin">
        <div className="mx-600 mx-auto h-100 position-relative">
          {!hideNavigation && (
            <>
              <div className="fs-16 d-flex justify-between w-100 mb-12 fw-600">
                <div>{stepText}</div>
                <div>{progress}</div>
              </div>
              <div className="mb-40 progressbar">
                <div
                  className="progressbarAbsolute"
                  style={{ width: progress }}
                />
              </div>
            </>
          )}
          {children}
        </div>
      </div>
      {isLogoutModal && (
        <LogoutModal
          isModalOpen={isLogoutModal}
          handleCancelChange={handleCancelLogout}
          handleConfirmChange={handleConfirmLogout}
        />
      )}
    </>
  );
};

export default EducationalContentHeader;
